import { useState } from "react";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";

export function DashboardLayout({ title, children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="sg-noise relative flex h-screen overflow-hidden bg-[#0A0A0A]">
      {/* Desktop sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setMobileOpen(false)}
          />
          <div className="absolute left-0 top-0 h-full">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      <div className="relative z-10 flex flex-1 flex-col overflow-hidden">
        <Topbar title={title} onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1 overflow-y-auto p-5 md:p-8">
          {children}
          <footer className="mt-12 flex flex-col items-center justify-between gap-2 border-t border-white/[0.06] pt-6 text-xs text-neutral-600 sm:flex-row" data-testid="app-footer">
            <span>SGBINOXE Care · <span className="text-neutral-500">Version 1.0</span></span>
            <span>© {new Date().getFullYear()} SGBINOXE</span>
          </footer>
        </main>
      </div>
    </div>
  );
}
